import * as THREE from 'three'
import fragmentShader from '../shaders/vinyl.frag'
import { bake, bakeQuad, scrambleSeed } from './bake'

const cache = new Map()
let quad = null

/**
 * A record's vinyl - colour pattern and label - baked once into a texture in disc
 * space (see shaders/vinyl.frag) and cached per record. Linear colour, so half float
 * rather than 8-bit to keep the darks clean.
 */
export function bakeVinylTexture({ colour, spots, seed, pattern, accent, core }) {
	const key = JSON.stringify([colour, spots, seed, pattern, accent, core])
	if (cache.has(key)) return cache.get(key)

	quad ??= bakeQuad(fragmentShader, {
		uColour: { value: new THREE.Color() },
		uSpots: { value: new THREE.Color() },
		uPattern: { value: 0 },
		uAccent: { value: new THREE.Color() },
		uCore: { value: new THREE.Color() },
		uSeed: { value: 0 },
	})
	const { uniforms } = quad.material
	uniforms.uColour.value.set(colour)
	uniforms.uSpots.value.set(spots)
	uniforms.uPattern.value = pattern === 'splatter' ? 1 : 0
	uniforms.uAccent.value.set(accent ?? spots)
	uniforms.uCore.value.set(core ?? colour)
	uniforms.uSeed.value = scrambleSeed(seed)

	const texture = bake(quad, { type: THREE.HalfFloatType })
	cache.set(key, texture)
	return texture
}
